// Type inference for:
// ```js
// Object.fromEntries(Object.entries(obj).filter(someFilter))
// ```
export function objectFilter(obj, filter) {
    return Object.fromEntries(Object.entries(obj).filter(filter));
}
